<template>
    <div class="summary--wrapper container" :class="`position-color-${position.departments[0].color}`">
        <div class="summary">
            <h1 class="heading--lg">{{position.title}} </h1>
            <p class="text-sub-header position-title">{{position.sub_title}}</p>
            <div class="divider"></div>
            <p class="paragraph" v-html="position.description"></p>
            <div class="divider"></div>

            <h3 class="special-field heading--sm" v-if="position.responsibilities&&responsibilities!==''">{{position.responsibilities_field}}</h3>
            <div class="special-field-desc" v-if="position.responsibilities&&responsibilities!==''" v-html="position.responsibilities"></div>
            <h3 class="special-field heading--sm" v-if="position.requirements&&requirements!==''">{{position.requirements_field}}</h3>
            <div class="special-field-desc" v-if="position.requirements&&requirements!==''"  v-html="position.requirements"></div>
            <h3 class="special-field heading--sm" v-if="position.offers&&offers!==''">{{position.offers_field}}</h3>
            <div class="special-field-desc" v-if="position.offers&&offers!==''" v-html="position.offers"></div>

            <div class="divider"></div>
            <div class="text-red text-warning">Applicants should submit their portfolio and CV detailing their previous work experience as well as a cover letter outlining their interest to work for Bohemia Interactive.</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PositionSummary",
        props: {
            position: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";
    @import "../../assets/scss/mixins";

    .summary--wrapper {
        background-color: white;
    }

    .position-title{
        font-family: Montserrat,sans-serif;
        font-size: 35px;
        font-weight: 300;
        letter-spacing: 0.19px;
        margin-top: 40px;
    }
    .paragraph{
        font-family: "Inter UI",sans-serif;
        line-height: 28px;
        letter-spacing: 0.02px;
        font-weight: 400;
        font-size: 16px;
    }
    .special-field{
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-weight: 800;
        line-height: 28px;
        letter-spacing: 0.02px;
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .special-field-desc{
        font-family: "Inter UI",sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 0.02px;
    }
    .text-warning{
        margin-bottom: 50px;
        margin-top: 50px;
        font-size: 18px;
        font-family: "Inter UI",sans-serif;
        font-weight: 700;
        letter-spacing: 0.03px;
        line-height: 34px;
    }
    .summary {
        @media (max-width: $mq-xs-max) {
             padding-top: 25px;
        }
        padding-top: 106px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .position-color-0 {
        .position-title{
            color: #000;
        }
    }
    .position-color-1 {
        .position-title{
            color: #f44d52;
        }
    }

    .position-color-2 {
        .position-title{
            color: #f01459;
        }
    }

    .position-color-3 {
        .position-title{
            color: #9300bb;
        }
    }

    .position-color-4 {
        .position-title{
            color: #401587;
        }
    }

    .position-color-5 {
        .position-title{
            color: #02b5f2;
        }
    }

    .position-color-6 {
        .position-title{
            color: #00a3ad;
        }
    }

    .position-color-7 {
        .position-title{
            color: #16bb7c;
        }
    }

    .position-color-8 {
        .position-title{
            color: #fdc209;
        }
    }

    .position-color-9 {
        .position-title{
            color: #ff8125;
        }
    }

    .position-color-10 {
        .position-title{
            color: #607d8b;
        }
    }

    .position-color-11 {
        .position-title{
            color: #1a1a1a;
        }
    }

    .position-color-12 {
        .position-title{
            color: #6e0031;
        }
    }

    .position-color-13 {
        .position-title{
            color: #151a93;
        }
    }





</style>


// WEBPACK FOOTER //
// src/components/positionPageComponents/PositionSummary.vue